


//--- document ready start ---- 
$(document).ready(function () {
  
      var currentUrl = window.location.href;
    // $("#pre-loading").fadeOut(2000);


      let storedData = JSON.parse(localStorage.getItem('DeliveryData'));
   
  
  if( $(".custom__description").length ){  
    $('.custom__description').each(function(){
      
    var content = $(this).find("p").html(); 
    var wordLimit = $(this).next().attr('limit');

    //console.log(content);
    var words = content.match(/\S+\s*/g); 
    
    if (words.length > wordLimit) {
        var visibleText = words.slice(0, wordLimit).join(""); 
        var hiddenText = words.slice(wordLimit).join(""); 
        
        $(this).html(`${visibleText}<span class="dots">...</span><span class="more-text">${hiddenText}</span>`);
    }else{
      $(this).next().hide();
    }

    });
  }

  
      $('body').on('click', '.custom_read_more', function () {
        var $this = $(this);
        var $moreText = $(this).prev().find(".more-text");
        var $dots =  $(this).prev().find(".dots");

        $moreText.toggle();
        $dots.toggle();

        if ($moreText.is(":visible")) {
            $this.text("Lees minder");
        } else {
            $this.text("Lees meer");
        }
    });


  
    

    //---- custom product bar ---- 
    $('body').on('click', '.custom_section_slider .section_item.scroll', function () {
        $(this).addClass('active');
        $('.custom_section_slider .section_item.scroll').not(this).removeClass('active');

        var matchetxt = $(this).attr('section-name').trim();

        var $matchedElement = $("body *").filter(function () {
            return $(this).text().trim() === matchetxt;
        }).first();

        var $matchedsect = $matchedElement.closest('.shopify-section');

        //if ($matchedsect.length) {
        $('html, body').animate({
            scrollTop: $matchedsect.offset().top - 320
        }, 800, 'swing'); 
        // }
    });

    //--- Product form start ----
    function customproductform() {


        var index = 0,
            divs = $(".upsell_step_allcontent").children(),
            step_names = $(".stepper_subheadings").children(),
            stepper_items = $(".upsell__steppers").children();

        divs.hide().eq(index).show();
        $(".prev_step").prop("disabled", true);

        // Initialize step name and active class for the first step
        step_names.hide().eq(index).show();
        stepper_items.eq(index).addClass("active");

        $("body").on("click", ".next_step, .skip_this_step", function () {
            if (index < divs.length - 1) {
                index++;
                divs.eq(index).show().siblings().hide();

                // Add active class to current and previous steps
                stepper_items.slice(0, index + 1).addClass("active");
                step_names.hide().eq(index).show();
            }

            if (index === divs.length - 1) {
                //  $(".next_step").prop("disabled", true);
                $(".next_step").hide();
                $(".skip_this_step").hide();
                $(".stepper_atc_btn").show();

            }

            $(".prev_step").prop("disabled", false);
        });


        $("body").on("click", ".prev_step", function () {
            if (index > 0) {
                index--;
                divs.eq(index).show().siblings().hide();
                // Remove active class only from the next step (one at a time)
                stepper_items.eq(index + 1).removeClass("active");
                step_names.hide().eq(index).show();
               }

            if (index === 0) {
                $(".prev_step").prop("disabled", true);
            } else {
                $(".prev_step").prop("disabled", false);
            }

            // $(".next_step").prop("disabled", false);
            $(".next_step").show();
            $(".skip_this_step").show();
            $(".stepper_atc_btn").hide();

        });


        $('.upsell_stepper_content').each(function () {
            var thisevent = $(this);
            var proCount = $(this).find(".upsell_product_item").length;
            if (proCount > 3) {
                $(this).find(".upsell_product_item").slice(0, 3).show();
                $('body').on("click", ".stepper_load_more", function () {
                    thisevent.find(".upsell_product_item:hidden").slice(0, 3).slideDown();
                    thisevent.animate({
                        scrollTop: $(this).offset().top
                    }, 1500);
                });
            } else {
                $(this).find(".upsell_product_item").show();
                $(this).next().hide();
            }

        });
      if($('.upsell_step_content').length <=1){
                $(".next_step").hide();
                $(".skip_this_step").hide();
                $(".stepper_atc_btn").show();
      }
      

      
    }

    customproductform();
    $('body').on("click", ".all_summary_items", function () {
        $('.collapsible_summary').not(':nth-of-type(1)').slideToggle();
    });
    //---- Product form end ----


    //----- Product form ATC -----

  
    function total_price() {
        var totalPrice = 0;
         var cost = $('.vat_shipping_price').attr('sel-price');
        $(".booking_product_items").each(function () {
            var This_product = $(this);
        var ProTitle = This_product.find('.product_name').val();
        var ProPrice = This_product.find('.hidden_price').val();
        var ProId = This_product.find('.variant_id').val();
          


            var proqnty = $(this).find('.qnty_value').val();

          if (proqnty != 0) {
            var proprice  = $(this).find('.pro_price2').text();
            var split = proprice.split('€');
            var price = parseFloat(split[1]);
 
$('.form_summary_container').find('.form_summary.' + ProId + '').remove();
$('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + proqnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
This_product.find('.selected_quantity .feedback-output').html(proqnty + ' geselecteerd');
This_product.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).addClass('selected');

     //totalPrice += price;  
    totalPrice += price * proqnty ;  

            
            }
        });

        var rental_days = $('.custom_product_form .rental_days_count ').attr('count');
        if (rental_days && rental_days != 0) {
    
            var rentalDays = parseFloat(rental_days);
            var total = parseFloat(totalPrice);
            var additionalCost = parseFloat(cost);
        
            var rental_subtotal = total * rentalDays;
            var rental_subtotal2 = total * rentalDays + additionalCost;

        
            // Update the amount box with the subtotal
            $('.atc-container').find('.amount-box').text('€' + rental_subtotal.toFixed(2));
            $('.atc-container').find('.amount-box').attr('price', rental_subtotal.toFixed(2));
           $('.final_vat_subtotal').html('€' + rental_subtotal2.toFixed(2));

          
        } else {
            $('.atc-container').find('.amount-box').html('€' + totalPrice.toFixed(2));
            $('.atc-container').find('.amount-box').attr('price', + totalPrice.toFixed(2));
                var final_price = parseFloat(cost) + parseFloat(totalPrice);
                $('.final_vat_subtotal').html('€' + final_price.toFixed(2));
        }

    }

    total_price();




$('body').on('change', '.product_items_flex .qnty_value', function () {
    var mainQnty = $(this).attr('main-qnty');
    var InputQnty = parseInt($(this).val(), 10) || 0; // Ensure we have a number
    var ThisProduct = $(this).closest('.product_items_flex');
    var maximum_qnty = parseInt($(this).parent().find('.maximum_qnty').val(), 10) || Infinity;
    var minimum_qnty = parseInt($(this).parent().find('.minimum_qnty').val(), 10) || 0;
    var ProId = ThisProduct.find('.variant_id').val();
    var ProTitle = ThisProduct.find('.product_name').val();
    var ProPrice = ThisProduct.find('.hidden_price').val();

    if (ThisProduct.hasClass('quantity-sec')) {
        if (InputQnty > maximum_qnty) {
          
            $(this).val(maximum_qnty);
            $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
            $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + maximum_qnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
            ThisProduct.find('.selected_quantity .feedback-output').html(maximum_qnty + ' geselecteerd');
            ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).closest('.booking_product_items').addClass('selected');
            ThisProduct.addClass('active');
            total_price();
          
        } else if (InputQnty < minimum_qnty) {
          
            $(this).val(minimum_qnty);
            $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
            $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + minimum_qnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
            ThisProduct.find('.selected_quantity .feedback-output').html(minimum_qnty + ' geselecteerd');
            ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).closest('.booking_product_items').addClass('selected');
            ThisProduct.addClass('active');
            total_price();
          
        } else {

            $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
            $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + InputQnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
            ThisProduct.find('.selected_quantity .feedback-output').html(InputQnty + ' geselecteerd');
            ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).closest('.booking_product_items').addClass('selected');
            ThisProduct.addClass('active');
            total_price();
        }
    } else {

        if (InputQnty < minimum_qnty) {
          
            $(this).val(minimum_qnty);
            $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
            $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + minimum_qnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
            ThisProduct.find('.selected_quantity .feedback-output').html(minimum_qnty + ' geselecteerd');
            ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).closest('.booking_product_items').addClass('selected');
            ThisProduct.addClass('active');
            total_price();
          
        } else {
            
            $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
            $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + InputQnty + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
            ThisProduct.find('.selected_quantity .feedback-output').html(InputQnty + ' geselecteerd');
            ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            $(this).closest('.booking_product_items').addClass('selected');
            ThisProduct.addClass('active');
            total_price();
        }
    }


if(InputQnty == 0 ){
    $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
    ThisProduct.find('.feedback-sec.selected_quantity').hide();
    $(this).closest('.booking_product_items').removeClass('selected');
    ThisProduct.removeClass('active');
}

});


  
    $(document).on('click', '.product_items_flex .price_plus', function () {
      $(this).parent().closest('.product_items_flex').addClass('active');
      $(this).parent().closest('.product_items_flex').find('.custom-feedback-sec').hide();
      $(this).parent().closest('.product_items_flex').find('.quantity-heading').show();
        var ThisProduct = $(this).parent().closest('.product_items_flex');
        var ProTitle = ThisProduct.find('.product_name').val();
        var ProPrice = ThisProduct.find('.hidden_price').val();
        var ProId = ThisProduct.find('.variant_id').val();

        var maximum_qnty = $(this).parent().find('.maximum_qnty').val();
        var value = $(this).prev().val();
        var newValues = parseInt(value);
        newValues = isNaN(newValues) ? 0 : newValues;

        var product_price = $(this).closest('.product_items_flex').find('.hidden_price').val();
        var split = product_price.split('€');
        var pro_price = parseFloat(split[1]);

        if ($(this).closest('.product_items_flex').hasClass('quantity-sec') && maximum_qnty > 0) {
            if (!isNaN(newValues)) {
                if (newValues < maximum_qnty) {

                    newValues++;
                    var final_price = pro_price * newValues;
                    //$(this).closest('.product_items_flex').find('.pro_price2').html('€' + final_price.toFixed(2));
                    $(this).prev().val(newValues);
                    total_price();

                    $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
                    $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + newValues + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
                    ThisProduct.find('.selected_quantity .feedback-output').html(newValues + ' geselecteerd');
                    ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
                    $(this).parent().closest('.booking_product_items').addClass('selected');
                }
            }
        } else {


            if (!isNaN(newValues)) {
                newValues++;
                var final_price = pro_price * newValues;
               // $(this).closest('.product_items_flex').find('.pro_price2').text('€' + final_price.toFixed(2));
                $(this).prev().val(newValues);
                total_price();
                $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
                $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + newValues + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
                ThisProduct.find('.selected_quantity .feedback-output').html(newValues + ' geselecteerd');
                ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
                $(this).parent().closest('.booking_product_items').addClass('selected');
            }
        }


    });


    $(document).on('click', '.product_items_flex .price_minus', function () {
        var ThisProduct = $(this).parent().closest('.product_items_flex');
        var ProTitle = ThisProduct.find('.product_name').val();
        var ProPrice = ThisProduct.find('.hidden_price').val();
        var ProId = ThisProduct.find('.variant_id').val();

        var minimum_qnty = $(this).parent().find('.minimum_qnty').val();
        var values = $(this).next().val();
        var nawValue = parseInt(values);
        nawValue = isNaN(nawValue) ? 0 : nawValue;

        var product_price = $(this).parent().closest('.product_items_flex').find('.hidden_price').val();
        var split = product_price.split('€');
        var pro_price = split[1];

        if (nawValue > minimum_qnty) {
            nawValue--;
            var final_price = pro_price * nawValue;
           // $(this).parent().closest('.product_items_flex').find('.pro_price2').val('€' + final_price + '.00');
            $(this).next().val(nawValue);
            total_price();
            if (nawValue > 0) {
                $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
                $('.form_summary_container').append('<div class="form_summary  ' + ProId + '"><div class="form_summary_product">' + nawValue + 'x ' + ProTitle + '</div><div class="form_summary_price">' + ProPrice + '</div></div>');
                ThisProduct.find('.selected_quantity .feedback-output').html(nawValue + ' geselecteerd');
                ThisProduct.find('.feedback-sec.selected_quantity').css('display', 'flex');
            } else {
                $('.form_summary_container').find('.form_summary.' + ProId + '').remove();
                ThisProduct.find('.feedback-sec.selected_quantity').hide();
            }
        }
    if(nawValue == '0'){
      $(this).parent().closest('.product_items_flex').removeClass('active');
      $(this).parent().closest('.product_items_flex').find('.custom-feedback-sec').show();
      $(this).parent().closest('.product_items_flex').find('.quantity-heading').hide();
      $(this).parent().closest('.booking_product_items').removeClass('selected');
    }
      
    });


    $('body').on('click', '.custom_form_atc', function () {

        var help_msg = $('.custom_product_form').find('.custom_help_message').val();
        var multiplechoice_text = $('.pro_form_dropdown').find("dropdown_title").text();
        var multiple_choice = $('.time-selectbox-inner').find("input:checked").val();
        var commnet_value = $('.custom_product_form').find('.commnet_value').val();
        var short_text = $('.custom_product_form').find('.short_text').val();
        var long_text = $('.custom_product_form').find('.long_text').val();
        var number_field = $('.custom_product_form').find('.custom_form_number').val();
        var available_dates = $('.custom_product_form').find('.order_summary_date').attr('date');
        var rental_start_date = $('.custom_product_form').find('.order_summary_sdate').attr('start-date');
        var rental_end_date = $('.custom_product_form').find('.order_summary_edate').attr('end-date');
        var rentalday_count = $('.custom_product_form').find('.rental_days_count ').attr('count');


        var properties = {};


        if (available_dates) {
            properties['Datums'] = available_dates;
        }
        if (rental_start_date) {
            properties['Start datum'] = rental_start_date;
        }
        if (rental_end_date) {
            properties['Eind datum'] = rental_end_date;
        }
        if (rental_end_date) {
            properties['Eind datum'] = rental_end_date;
        }
        if (rentalday_count) {
            properties['Aantal huurdagen'] = rentalday_count + ' dagen';
        }
        if (help_msg) {
            properties['Help-bericht'] = help_msg;
        }
        if (multiple_choice) {
            properties['Tijdstip'] = multiple_choice;
        }
        if (commnet_value) {
            properties['Comment'] = commnet_value;
        }
        if (short_text) {
            properties['Short Text'] = short_text;
        }
        if (long_text) {
            properties['Long Text'] = long_text;
        }
        if (number_field) {
            properties['Number Field'] = number_field;
        }


        var all_ID = [];
        rental_count = $('.custom_product_form .rental_days_count').attr('count');
        $(".booking_product_items.selected").each(function (index) {
            if (index == 0 && rental_count != 0) {
                // var all_variant_qnty = parseInt($(this).find('.qnty_value').text()) + rental_count;
                var all_variant_qnty = parseInt($(this).find('.qnty_value').val(), 10) * parseInt(rental_count, 10);

            } else {
                var all_variant_qnty = $(this).find('.qnty_value').val();
            }


            if (all_variant_qnty > 0) {
                var all_variant_id = $(this).find('.variant_id').val();

                var itemProperties = {};
                if (index == 0) {
                    itemProperties = properties;
                }

                all_ID.push({
                    quantity: parseInt(all_variant_qnty),
                    id: parseInt(all_variant_id),
                    properties: itemProperties
                });
            }

         
            //**----Pick n Mix ----**//
        if($(this).hasClass('arrangement-items') && all_variant_qnty > 0 ){
             var pick_max = $(this).find('.max-min-items').attr('max');
             var pick_min = $(this).find('.max-min-items').attr('min');
             $('.upsell_product_sec').find('.max_count').html(pick_max);
               if(pick_max > 0){
                 $('.upsell_product_sec .pick_min').addClass('show').css('display','flex');
                }else{
                 $('.upsell_product_sec .pick_min').removeClass('show').hide();
                }
            }
          
        });
      

var startDateLength = $('.rental-days-sec.rental_start');
var startDate = $('.rental-days-sec.rental_start').find('.rental_start_date').val();
var endDateLength = $('.rental-days-sec.rental_end');
var endDate = $('.rental-days-sec.rental_end').find('.rental_end_date').val();
var timeLength = $('.pro_form_dropdown');
var bookingTime = timeLength.find('.booking_time').text().trim();
      


var hasError = false;

if (startDateLength.length) {
    if (startDate === '') {
        startDateLength.addClass('section_error');
      $('.custom_product_form').find('.date_time_error').show();
        hasError = true;
    } else {
        startDateLength.removeClass('section_error');
      $('.custom_product_form').find('.date_time_error').hide();
    }
}

// Check if end date div exists and is empty
if (endDateLength.length) {
    if (endDate === '') {
        endDateLength.addClass('section_error');
      $('.custom_product_form').find('.date_time_error').show();
        hasError = true;
    } else {
        endDateLength.removeClass('section_error');
       $('.custom_product_form').find('.date_time_error').hide();
    }
}

// Check if booking time div exists and is empty
if (timeLength.length) {
    if (bookingTime=='Selecteer een tijdstip') {
        timeLength.addClass('section_error');
      $('.custom_product_form').find('.date_time_error').show();
        hasError = true;
    } else {
        timeLength.removeClass('section_error');
       $('.custom_product_form').find('.date_time_error').hide();
    }
}

// If no errors, proceed with AJAX
if (!hasError) {
    console.log('Ajax add to cart');
  
    // Place AJAX code here


$.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: all_ID

            },
            dataType: 'json',
            success: function (data) {


              $.ajax({
                  type: 'GET',
                  url: '/cart.json',
                   success: function (data) { 
                     // console.log(data.item_count);
                      $('.header_cart_count').show();
                      $('.cart-count').html(data.item_count);
                   }
                   });
              
                $('.custom_product_form').find('.success_msg').css('display', 'flex');
                setTimeout(function () {
                    $('.custom_product_form').find('.success_msg').hide();
                    var modal = document.getElementById("main_popup_container");
                    if ($('#main_popup_container').length) {
                        $('#main_popup_container').fadeIn();
                        $('body').addClass('showing-custom-popup');
                    }else{
                      window.location.href = "/checkout";
                    }
                }, 1000);

            },
            error: function (data) {
                $('.custom_product_form').find('.error_msg').text(data.responseJSON.description).show();
                setTimeout(function () {
                    $('.custom_product_form').find('.error_msg').text('').hide();
                }, 2000);

            }
        });


  
} else {
    console.log('Errors found, fix the inputs.');
}
      
    
        

      
    });


    $('body').on('change', '.time-select-dropdown input ', function () {
        var optionSelected = $(this).val();
        $('.custom_product_form .order_summary_time').html('Tijdstip: ' + optionSelected + '');
        $('.pro_form_dropdown .booking_time').html(optionSelected);
        $('.pro_form_dropdown .feedback-sec').css('display', 'flex');
        $('.pro_form_dropdown').removeClass('section_error');
        $('.atc-container .time_estimate.atc').show();
        $('.custom_product_form').find('.date_time_error').hide();
    });


    //----- Stepper popup functionality -----

    function stepper_total_price() {
        var totalPrice = 0;
        $(".upsell_product_sec .extra_popup_item ").each(function () {
            var proprice = $(this).find('.pro_price2').text();
            var proqnty = $(this).find('.qnty_value').text();
            if (proqnty != 0) {
                var split = proprice.split('€');
                var price = parseFloat(split[1]);
                totalPrice += price;
            }
        });
        $('.upsell_product_sec').find('.stepper_total_price').text(' | €' + totalPrice.toFixed(2));
        $('.upsell_product_sec').find('.upsell.amount-box').text('€' + totalPrice.toFixed(2));
    }


    $(document).on('click', '.extra_popup_item .price_plus', function () {
        var ThisProduct = $(this).parent().closest('.extra_popup_item');
        var ProTitle = ThisProduct.find('.order_pr_title').text();
        var ProPrice = ThisProduct.find('.upsell_product_price.pro_price').text();
        var ProId = ThisProduct.find('.upsell_variant_id').val();

        var value = $(this).prev().text();
        var newValues = parseInt(value);
        newValues = isNaN(newValues) ? 0 : newValues;

        var product_price = $(this).closest('.extra_popup_item').find('.hidden_price').val();
        var split = product_price.split('€');
        var pro_price = parseFloat(split[1]);

        if (!isNaN(newValues)) {
            newValues++;
            var final_price = pro_price * newValues;
            $(this).closest('.extra_popup_item').find('.pro_price2').text('€' + final_price.toFixed(2));
            $(this).prev().text(newValues);
            stepper_total_price();
            $('.collapsible_summary_container').find('.collapsible_summary.' + ProId + '').remove();
            //$('.collapsible_summary_container').append('<div class="collapsible_summary  ' + ProId + '"><div class="collapsible_summary_inner"><div class="summary_product">' + newValues + 'x ' + ProTitle +'<span></div><div class="summary_price">' + ProPrice + '</div></div></div>');

        var summary_html = '<div class="collapsible_summary  ' + ProId + '" var-id="'+ProId+'"><div class="collapsible_summary_inner"><div class="summary_product">' + newValues + 'x ' + ProTitle +'<span class="remove_summary">';
        summary_html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="delete" width="30" height="30">';
        summary_html += '<path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z">';
        summary_html +='</path></svg></span></div><div class="summary_price">' + ProPrice + '</div></div></div>';
    
      $('.collapsible_summary_container').append(summary_html);

          
          var DivLength = $('.collapsible_summary').length;
            if (DivLength > 1) {
               // console.log(DivLength);
                $('.summary_other_items').html('' + DivLength - 1 + ' overige items');
                $('.load_summary_items').show();
            } else {
                $('.summary_other_items').html('');
                $('.load_summary_items').hide();
            }
        }
         
          if($('.upsell_product_sec .pick_min').hasClass('show')){
            var max_pick = $('.upsell_product_sec .pick_min').find('.max_count.max').html();
            //alert('max_pick--- '+max_pick+' , DivLength---'+DivLength);
            if(DivLength <= max_pick){
              $('.upsell_product_sec .pick_min').find('.pick_select_count').html(DivLength);
              $('.upsell_product_sec .pick_min').find('.pick_min_text').html('Jij hebt <span class="max_count">'+DivLength+'</span> items geselecteerd.');
            }
            if(DivLength == max_pick){
               $('.upsell_product_sec').find('.chosen_items_error').fadeIn();
               setTimeout(function () {
               $('.upsell_product_sec').find('.chosen_items_error').fadeOut();
               },2000);
            }
          }


      
    });

   $('body').on('click', '.upsell_product_sec .chosen_items_close', function () {
     $('.upsell_product_sec').find('.chosen_items_error').fadeOut();
   });
  
    $(document).on('click', '.extra_popup_item .price_minus', function () {
        var ThisProduct = $(this).parent().closest('.extra_popup_item');
        var ProTitle = ThisProduct.find('.order_pr_title').text();
        var ProPrice = ThisProduct.find('.upsell_product_price.pro_price').text();
        var ProId = ThisProduct.find('.upsell_variant_id').val();

        var minimum_qnty = $(this).parent().find('.minimum_qnty').val();
        var values = $(this).next().text();
        var nawValue = parseInt(values);
        nawValue = isNaN(nawValue) ? 0 : nawValue;

        var product_price = $(this).parent().closest('.extra_popup_item').find('.hidden_price').val();
        var split = product_price.split('€');
        var pro_price = split[1];

        if (nawValue > minimum_qnty) {
            nawValue--;
            var final_price = pro_price * nawValue;
            $(this).parent().closest('.extra_popup_item').find('.pro_price2').text('€' + final_price + '.00');
            $(this).next().text(nawValue);
            stepper_total_price();
            //console.log(nawValue); 

            $('.collapsible_summary_container').find('.collapsible_summary.' + ProId + '').remove();
            //$('.collapsible_summary_container').append('<div class="collapsible_summary  ' + ProId + '"><div class="collapsible_summary_inner"><div class="summary_product">' + nawValue + 'x ' + ProTitle + '</div><div class="summary_price">' + ProPrice + '</div></div></div>');
        var summary_html = '<div class="collapsible_summary  ' + ProId + '" var-id="'+ProId+'"><div class="collapsible_summary_inner"><div class="summary_product">' + nawValue + 'x ' + ProTitle +'<span class="remove_summary">';
        summary_html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="delete" width="30" height="30">';
        summary_html += '<path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z">';
        summary_html +='</path></svg></span></div><div class="summary_price">' + ProPrice + '</div></div></div>';
    
      $('.collapsible_summary_container').append(summary_html);
          
            var DivLengthh = $('.collapsible_summary').length;;
            //console.log(DivLengthh);
            if (DivLengthh > 2) {
                $('.summary_other_items').html('' + DivLengthh - 2 + ' overige items');
                $('.load_summary_items').show();
            } else {
                $('.summary_other_items').html('');
                $('.load_summary_items').hide();
            }

            if (nawValue > 0) {
            } else {
                $('.collapsible_summary_container').find('.collapsible_summary.' + ProId + '').remove();
            }
        }
            if($('.upsell_product_sec .pick_min').hasClass('show')){
            var max_pick = $('.upsell_product_sec .pick_min').find('.max_count.max').html();
           // alert('max_pick--- '+max_pick+' , DivLength---'+DivLengthh);
            var current_count = DivLengthh - 1 ;
            if(DivLengthh <= max_pick){
              $('.upsell_product_sec .pick_min').find('.pick_select_count').html(current_count);
              $('.upsell_product_sec .pick_min').find('.pick_min_text').html('Jij hebt <span class="max_count">'+current_count+'</span> items geselecteerd.');
            } 
              if(DivLengthh - 1 == 0){
                pickmax = $('.upsell_product_sec .pick_min').find('.max_count.max').text();
                $('.upsell_product_sec .pick_min').find('.pick_min_text').html('Kies <span class="max_count">'+pickmax+'</span> items in jouw arrangement');
              }
          }
    });

    $('body').on('click', '.upsell_product_sec .remove_summary', function () {
      $(this).closest('.collapsible_summary').remove();
     var remove_summary = $(this).closest('.collapsible_summary').attr('var-id');
      $('.upsell_product_item').each(function(){
        var martchId = $(this).find('.upsell_variant_id').val();
        if(remove_summary == martchId ){
          $(this).find('.qnty_value').text('0');
           stepper_total_price();
           var DivLengthh = $('.collapsible_summary').length;;
          console.log(DivLengthh);
            if (DivLengthh > 1) {
                $('.summary_other_items').html('' + DivLengthh - 1 + ' overige items');
                $('.load_summary_items').show();
            } else {
                $('.summary_other_items').html('');
                $('.load_summary_items').hide();
            }
        }
      });

      
     });
  
    $('body').on('click', '.stepper_atc_btn', function () {
        var all_upsell_ID = [];
        $(".extra_popup_item").each(function (index) {

            var all_variant_qnty = $(this).find('.qnty_value').text();
            if (all_variant_qnty > 0) {
                var all_variant_id = $(this).find('.upsell_variant_id').val();

                all_upsell_ID.push({
                    quantity: parseInt(all_variant_qnty),
                    id: parseInt(all_variant_id)
                });

            }
        });

//console.log(all_upsell_ID)
if (all_upsell_ID.length != 0) {

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: all_upsell_ID

            },
            dataType: 'json',
            success: function (data) {
                $('.upsell_product_sec').find('.upsell_success_msg').show();
                window.location.href = "/cart";
                // setTimeout(function () {
                //   $('.upsell_product_sec').find('.upsell_success_msg').hide();
                // }, 1000);
            },
            error: function (data) {
                $('.upsell_product_sec').find('.upsell_error_msg').text(data.responseJSON.description).show();
                setTimeout(function () {
                    $('.upsell_product_sec').find('.upsell_error_msg').text('').hide();
                }, 2000);

            }
        });
}else{
  window.location.href = "/cart";
}
      
    });




    $('body').on('click', '.filter_plus', function (event) {
        event.stopPropagation();
        var $valueElement = $(this).next();
        var value = $valueElement.text();
        var newValues = parseInt(value, 10);
        newValues = isNaN(newValues) ? 0 : newValues;

        newValues++;
        $valueElement.text(newValues);
        console.log(newValues);
        $(this).parent().find('.filter-qnty-value ').val(newValues);
    });

    $('body').on('click', '.filter_minus', function (event) {
        event.stopPropagation();
        var $valueElement = $(this).prev();
        var value = $valueElement.text();
        var newValues = parseInt(value, 10);
        newValues = isNaN(newValues) ? 0 : newValues;

        if (newValues > 0) {
            newValues--;
            $valueElement.text(newValues);
            $(this).parent().find('.filter-qnty-value ').val(newValues);
        }
    });


    //------banner filter section end----------




//---------product form on collection page----------
// Disabled: collection quick popup (was causing JS errors / not used anymore).
// Button was replaced with <a href="..."> so users go to product page directly.

(function () {
  // If legacy markup doesn't exist, do nothing (prevents runtime errors)
  var coll_modal = document.getElementById("coll_popup_modal");
  var coll_inner = document.getElementById("coll_popup_inner");
  if (!coll_modal || !coll_inner) return;

  // If you ever re-enable this feature, restore the old handlers here.
})();

//------product from on collection page end----------

    $('body').on('click', '.calendar_popup_close', function () {
        $('body').removeClass('showing-custom-popup')
        $('.calendar_popup').fadeOut();
    });

    $('body').on('click', '.rental_calendar_close', function () {
        $('body').removeClass('showing-custom-popup')
        $('.rental_calendar_popup').fadeOut();
    });

    $('body').on('click', '.unavailable_date .calender-slider-item', function () {
        $(this).parent().closest('.available_dates_cale').find('.unavailable_date_popup').fadeIn();
        setTimeout(function () {
            $('.unavailable_date_popup').fadeOut();
        }, 2000);
    });

    $('body').on('click', '.date_popup_close', function () {
        $('.unavailable_date_popup').fadeOut();
    });


    //----- header customer card ----

    $('body').on('click', '.experience_card img', function () {
        $('.experience-card-popup').fadeIn();
        $('body').addClass('body_fixed');
    });
    $('body').on('click', '.experience-card-popup .close-icon', function () {
        $('.experience-card-popup').fadeOut();
        $('body').removeClass('body_fixed');
    });

    $('body').on('click', '.become_exp_member', function () {
        $('.experience-card-popup').fadeOut();
        $('.experience-member-wrapper').fadeIn();
        $('body').addClass('body_fixed');
    });
    $('body').on('click', '.experience-member-wrapper .close-icon', function () {
        $('.experience-member-wrapper').fadeOut();
        $('body').removeClass('body_fixed');
    });



    $(document).on('click', '.close_upsell_popup', function () {
        $('#main_popup_container').fadeOut();
        $('body').removeClass('showing-custom-popup');
    });


    $('body').on('click', '.item_popup_msg', function () {
        var popup_content = $(this).parent().find('.popup_msg_content').val();
        $('.item_msg_modal').find('.main_inner_content').html(popup_content);
      if(popup_content){
        $('body').addClass('showing-custom-popup')
        $('#item_msg_modal').show();
      }
        
    });


    $('body').on('click', '.qusmark_popup', function () {
        var popup_content = $(this).parent().next().val();
        $('.item_msg_modal').find('.main_inner_content').html(popup_content);
      if(popup_content){
        $('#item_msg_modal').show();
        $('body').addClass('showing-custom-popup')
      }
    });


    $('body').on('click', '.item_msg_close', function () {
        $('#item_msg_modal').hide();
        $('body').removeClass('showing-custom-popup');
    });



    //------------ Window popup close --------  
    var modal = document.getElementById("main_popup_container");
    var item_msg_modal = document.getElementById("item_msg_modal");
    var location_modal = document.getElementById("location_tracker_inner");
    var available_location_msg = document.getElementById("available_location_msg");
    var experience_card_popup = document.getElementById("experience_card_popup");
    var buy_exp_card = document.getElementById("buy-experience-card");
    var calendar_popup = document.getElementById("calendar_popup");
    var rental_calendar_popup = document.getElementById("rental_calendar_popup");
    var rental_calendar_second = document.getElementsByClassName("rental_calendar_popup second");
    var load_delivery_location = document.getElementById("delivery-location-main");
    var selected_location = document.getElementById("selected-location-msg");
    var time_selectbox_sec = document.getElementById("time-selectbox-sec");
  
    window.onclick = function (event) {
        // Legacy collection popup modal (may be removed from DOM)
// Keep as global so window.onclick doesn't crash
var coll_modal = document.getElementById("coll_popup_modal");

        if (event.target == load_delivery_location) {
            $(load_delivery_location).fadeOut(); 
        } 
       else if (event.target == selected_location) {
            $(selected_location).fadeOut();
        } 
       else if (typeof coll_modal !== 'undefined' && coll_modal && event.target == coll_modal) {
            $(coll_modal).fadeOut();
            $('body').removeClass('body_fixed');
        } 
        else if (event.target == item_msg_modal) {
            $(item_msg_modal).hide();
            $('body').removeClass('showing-custom-popup')
        }
        else if (event.target == modal) {
            $(modal).fadeOut();
            $('body').removeClass('showing-custom-popup');
        }
        else if (event.target == location_modal) {
            $('#location_tracker_inner').removeClass('show_location_track');
        }
        else if (event.target == available_location_msg) {
            $(available_location_msg).fadeOut();
            $('body').removeClass('showing-custom-popup');
        }
        else if (event.target == calendar_popup) {
            $(calendar_popup).fadeOut();
            $('body').removeClass('showing-custom-popup');
        }
        else if (event.target == rental_calendar_popup) {
            $(rental_calendar_popup).fadeOut();
            $('body').removeClass('showing-custom-popup');
        }
        else if (event.target == time_selectbox_sec ) {
            $(time_selectbox_sec).fadeOut();
            $('body').removeClass('showing-custom-popup');
        }

        else if (event.target == experience_card_popup) {
            $(experience_card_popup).fadeOut();
            $('body').removeClass('body_fixed');
        }
        else if (event.target == buy_exp_card) {
            $(buy_exp_card).fadeOut();
            $('body').removeClass('body_fixed');
        }


for (var i = 0; i < rental_calendar_second.length; i++) {
  if (event.target == rental_calendar_second[i]) {
    $(rental_calendar_second[i]).fadeOut();
    $('body').removeClass('showing-custom-popup');
  }
}


      
    }




    //-----Header Scroll menu ----

    var $scrollMenu = $('.horizontal_scroll_menu ul.parent-menu-scroll.active')
    var scrollLeft = $scrollMenu.scrollLeft();
    var scrollWidth = $scrollMenu.prop('scrollWidth');
    var clientWidth = $scrollMenu.innerWidth();

    if (scrollLeft + clientWidth >= scrollWidth) {
        $scrollMenu.find('.next_btn').prop('disabled', true);
    } else {
        $scrollMenu.find('.next_btn').prop('disabled', false);
    }

    $('body').on('click', '.next_btn', function (e) {
        e.stopPropagation();
        var $scrollMenu = $(this).parent();
        var clientWidth = $scrollMenu.innerWidth();
        var scrollWidth = $scrollMenu.prop('scrollWidth');

        // Scroll to the right
        $scrollMenu.animate({ scrollLeft: "+=200px" }, 600, "swing", function () {
            var scrollLeft = $scrollMenu.scrollLeft();

            // Check if we've reached the end
            if (scrollLeft + clientWidth >= scrollWidth - 1) {
                $(this).prop('disabled', true);
            } else {
                $(this).prop('disabled', false);
            }

            // Show the prev button
            $(this).prev().fadeIn();
        }.bind(this));
    });

    $('body').on('click', '.prev_btn', function (e) {
        e.stopPropagation();
        var $scrollMenu = $(this).parent();

        // Scroll to the left
        $scrollMenu.animate({ scrollLeft: "-=200px" }, 600, "swing", function () {
            var scrollLeft = $scrollMenu.scrollLeft();
            var clientWidth = $scrollMenu.innerWidth();
            var scrollWidth = $scrollMenu.prop('scrollWidth');

            // Check if we've reached the start
            if (scrollLeft <= 0) {
                $(this).fadeOut();
            } else {
                $(this).fadeIn();
            }

            // Enable the next button since we're moving back
            $(this).next().prop('disabled', false);
        }.bind(this));
    });




    $('body').on('click', '.horizontal_scroll_menu ul li span.link--text', function (e) {
        e.stopPropagation();

        var $el = $(this).parent().find('.first_menu_child');
        $('.horizontal_scroll_menu ul > li > ul').not($el).slideUp();
        $('.horizontal_scroll_menu ul > li > .link--text').removeClass('active');
        $el.slideToggle();
        $(this).toggleClass('active');

        var $scrollMenu = $(this).next().find('ul.child-menu-scroll');
        var scrollLeft = $scrollMenu.scrollLeft();
        var scrollWidth = $scrollMenu.prop('scrollWidth');
        var clientWidth = $scrollMenu.innerWidth();

        if (scrollLeft + clientWidth >= scrollWidth) {
            $scrollMenu.find('.next_btn').prop('disabled', true);
        } else {
            $scrollMenu.find('.next_btn').prop('disabled', false);
        }
    });


    $('body').on('change', '.desktop_switch_btns input , .mobile_switch_btns input', function () {
        var show_menu = $(this).attr('data-val');
       //  console.log(show_menu);
        if (show_menu == 'show_first_menu') {
            window.location.href = "/";
        } else {
            window.location.href = "/pages/zakelijk-bestellen";
        }
                
        if (localStorage.getItem('AccountType')) {
            localStorage.removeItem('AccountType');
        }
        localStorage.setItem('AccountType', show_menu);

      
    });

    $('body').on('change', '#private_business', function () {
        if (this.value == "Particulier") {
            $('.for_business').hide();
            $('.for_private').show();
        } else {
            $('.for_private').hide();
            $('.for_business').show();
        }
    });

    $('body').on('click', '.mobile_search_icon.mobile_header', function () {
        $('.mobile_search_form').show();
        $('#search-mobile').focus();
    });

    $('body').on('click', '.mobile_search_icon.mobile_menu', function () {
        $('.mobile_search_form').show();
        $('.main_drawe_mobile_menu').find('#search-mobile').focus();
    });


    $('body').on('click', '.mobile_search_form button[title="Cancel search"], .mobile-header-close-search', function () {
        $('.mobile_search_form').hide();
    });
  
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.mobile_menu_search ,.mobile_search_icon.mobile_header,.mobile_search_form').length) {
             $('.mobile_search_form').hide();
        }
    });

    $('body').on('click', '.top_checkout #checkout', function (event) {
       event.stopPropagation();
      event.preventDefault();
        window.location.href = "/checkout";
     });




//*----    NEW Version-3 -----*

$('body').on('click', '.switch_btn_dropdown', function () {
      $(".switch-field.desktop_switch_btns").slideToggle();
      $(this).toggleClass('active');
});
  
$('body').on('click', '.new-desktop-search', function () {
      $(".header_right_icons .desktop-search span").trigger('click');
});

  $(".delivery-icons").mouseover(function(){
    $(".tooltip_popup").show();
  });
  $(".delivery-icons").mouseout(function(){
    $(".tooltip_popup").hide();
  });
  
$('body').on('click', '.tooltip_popup .close-icon', function () {
      $(".tooltip_popup").hide();
});
  
$('body').on('click', '.pro_form_dropdown .dropdown_content_inner', function () {
      $(".pro_form_dropdown .time-selectbox-sec").show();
              $('body').addClass('showing-custom-popup');
});
  
$('body').on('click', '.pro_form_dropdown .time-selectbox-close', function () {
      $(".pro_form_dropdown .time-selectbox-sec").hide();
       $('body').removeClass('showing-custom-popup');
});

$('body').on('click', '.item_view_more', function () {
  var items =   $(this).prev().find(".booking_product_items.hide__items").slideToggle();
  var view_more = $(this).attr('more');
  var view_less = $(this).attr('less');
  
  $(this).toggleClass("active");
    if ($(this).hasClass('active')) {
        $(this).find('.view_more_text').html(view_less); // Show less
    } else {
        $(this).find('.view_more_text').html(view_more); // Show more
    }

});








  
  

    //--- document ready close ---- 
});



